module.exports = __webpack_public_path__ + "static/assets/57d3cee9ac3349a854ee30efa2915565.svg";